function validDate(year, month, day) {
  const date = new Date(Date.UTC(year, month - 1, day));
  return date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day;
}

// Keep ISO dates in storage so calendar matching and historical records stay compatible.
export function rocDateToIso(value) {
  const text = String(value || "").trim();
  if (!text) return "";
  const match = /^(\d{1,3})[/-](\d{1,2})[/-](\d{1,2})$/.exec(text)
    || /^(\d{3})(\d{2})(\d{2})$/.exec(text);
  if (!match) return null;
  const [, rocYear, month, day] = match.map(Number);
  const year = rocYear + 1911;
  if (rocYear < 1 || !validDate(year, month, day)) return null;
  return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
}

export function formatRocDate(value) {
  if (!value) return "";
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!match) return value;
  const [, year, month, day] = match.map(Number);
  if (!validDate(year, month, day) || year <= 1911) return value;
  return `${year - 1911}/${String(month).padStart(2, "0")}/${String(day).padStart(2, "0")}`;
}
